module.exports = __webpack_public_path__ + "static/img/iconfont.711dea6c.svg";